export default __webpack_public_path__ + "static/media/flower3.c0431c1a.png";